import { Box, Paper, Grid, Typography } from "@mui/material";

export default function EventsStepsHeader() {

    return <Box sx={{ width: '100%' }} component={Paper}>

        <Grid container rowSpacing={4}>

            <Grid size={{ xs: 12 }}></Grid>

            <Grid size={{ xs: 12 }} sx={{ marginLeft: '2%' }}>
                <Typography variant='h4'>
                    Application for CPD Approval
                </Typography>
            </Grid>

            <Grid size={{ xs: 12 }} sx={{ marginLeft: '2%', marginBottom: '2%' }}>
                <Typography variant='subtitle1'>
                    It is important to apply to the Postgraduate Training Body that best matches your audience.
                    Applications should be submitted at least four/six weeks in advance of the activity.
                    This gives us time to check and advise you of any issues in relation to your application.
                </Typography>
            </Grid>
        </Grid>
    </Box>
}
